enum PropertyOwnershipStatus {
  Available = 'available',
  Pending = 'pending',
  Unavailable = 'unavailable'
};

export default PropertyOwnershipStatus;
